import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../../../services/url.service';

@Component({
    selector: 'user-filter',
    templateUrl: './user-filter.component.html',
    styleUrls: ['./user-filter.component.scss']
})
export class UserFilterComponent implements OnInit {

    public showDropdown = false;

    @ViewChild('superAdmin') superAdminCheckbox: ElementRef;
    @ViewChild('companyAdmin') companyAdminCheckbox: ElementRef;
    @ViewChild('propertyManager') propertyManagerCheckbox: ElementRef;
    // @ViewChild('admin') adminCheckbox: ElementRef;
    @ViewChild('buildingStaff') buildingStaffCheckbox: ElementRef;
    @ViewChild('resident') residentCheckbox: ElementRef;
    @ViewChild('vendor') vendorCheckbox: ElementRef;
    @ViewChild('invited') invitedCheckbox: ElementRef;
    @ViewChild('notInvited') notInvitedCheckbox: ElementRef;
    @ViewChild('active') activeCheckbox: ElementRef;

    constructor(private urlService: UrlService) {
    }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {
            const permissions = this.urlService.queryParams['user_type'];
            if (permissions) {
                this.superAdminCheckbox.nativeElement.checked = permissions.indexOf('super_admin') !== -1;
                this.companyAdminCheckbox.nativeElement.checked = permissions.indexOf('company_admin') !== -1;
                this.propertyManagerCheckbox.nativeElement.checked = permissions.indexOf('property_manager') !== -1;
                // this.adminCheckbox.nativeElement.checked = permissions.indexOf('admin') !== -1;
                // this.buildingStaffCheckbox.nativeElement.checked = permissions.indexOf('buildingStaff') !== -1;
                this.residentCheckbox.nativeElement.checked = permissions.indexOf('resident') !== -1;
                // this.vendorCheckbox.nativeElement.checked = permissions.indexOf('vendor') !== -1;
            } else {
                this.superAdminCheckbox.nativeElement.checked = false;
                this.companyAdminCheckbox.nativeElement.checked = false;
                this.propertyManagerCheckbox.nativeElement.checked = false;
                // this.adminCheckbox.nativeElement.checked = permissions.indexOf('admin') !== -1;
                // this.buildingStaffCheckbox.nativeElement.checked = false;
                this.residentCheckbox.nativeElement.checked = false;
                // this.vendorCheckbox.nativeElement.checked = false;
            }

            const status = this.urlService.queryParams['status'];
            if (status) {
                this.invitedCheckbox.nativeElement.checked = status.indexOf('did_not_follow_link') !== -1;
                this.notInvitedCheckbox.nativeElement.checked = status.split(',').indexOf('inactive') !== -1;
                this.activeCheckbox.nativeElement.checked = status.split(',').indexOf('active') !== -1;
            } else {
                this.invitedCheckbox.nativeElement.checked = false;
                this.notInvitedCheckbox.nativeElement.checked = false;
                this.activeCheckbox.nativeElement.checked = false;
            }
        });

    }

    changeFilter() {
        let permissions: any = {};
        permissions['super_admin'] = this.superAdminCheckbox.nativeElement.checked;
        permissions['property_manager'] = this.propertyManagerCheckbox.nativeElement.checked;
        permissions['company_admin'] = this.companyAdminCheckbox.nativeElement.checked;
        // permissions['admin'] = this.adminCheckbox.nativeElement.checked;
        //permissions['staff'] = this.buildingStaffCheckbox.nativeElement.checked;
        permissions['resident'] = this.residentCheckbox.nativeElement.checked;
        //permissions['vendor'] = this.vendorCheckbox.nativeElement.checked;

        let permissionsQuery: string = '';
        for (const key in permissions) {
            if (permissions[key]) {
                permissionsQuery += key + ',';
            }
        }
        this.urlService.queryParams['user_type'] = permissionsQuery.slice(0, -1);

        const invitedCheckbox = this.invitedCheckbox.nativeElement.checked;
        const notInvitedCheckbox = this.notInvitedCheckbox.nativeElement.checked;
        const activeCheckbox = this.activeCheckbox.nativeElement.checked;

        if (!invitedCheckbox && !notInvitedCheckbox && !activeCheckbox) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (invitedCheckbox) status += 'did_not_follow_link,';
            if (notInvitedCheckbox) status += 'inactive,';
            if (activeCheckbox) status += 'active,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }

        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('.documents-status-filter')) this.showDropdown = false;
    }

}




// WEBPACK FOOTER //
// /app/src/app/views/admin/user/user-filter/user-filter.component.ts